import { Component } from '@angular/core';
import { IconComponent } from './icon.component';

@Component({
  selector: 'app-icon-close',
  template: `<span class="icon icon-close" [class.white]="color === 'white'"></span>`,
})
export class CloseIconComponent extends IconComponent { }
